import gql from "graphql-tag";

export const GET_PACKAGE_UPLOAD_URL = gql`
query preSignedURL ($filename: String!) {
  getPackageUploadSignedURL(filename:$filename) 
}
`;

export const GET_PACKAGE_UPLOAD_MULTIPART_INFO = gql`
query getPackageUploadMultipartInfo($filename: String!, $numberOfParts: Float!) {
  getPackageUploadMultipartInfo(filename: $filename, numberOfParts: $numberOfParts) {
    filename
    uploadId
    parts {
      eTag
      partNumber
      signedUrl
    }
  }
}
`;

export const COMPLETE_PACKAGE_UPLOAD_MULTIPART = gql`
  mutation completePackageUploadMultipart($filename: String!, $uploadId: String!, $eTags: String!) {
    completePackageUploadMultipart(filename: $filename, uploadId: $uploadId, eTags: $eTags)
  }
`;

export const GET_INSTA360_UPLOAD_URL = gql`
query getInsta360UploadSignedURL ($projectId: Float!, $filename: String!) {
  getInsta360UploadSignedURL(projectId: $projectId, filename:$filename)
}
`;

export const GET_INSTA360_UPLOAD_MULTIPART_INFO = gql`
query getInsta360UploadMultipartInfo($projectId: Float!, $filename: String!, $numberOfParts: Float!) {
  getInsta360UploadMultipartInfo(projectId: $projectId, filename: $filename, numberOfParts: $numberOfParts) {
    filename
    uploadId
    parts {
      eTag
      partNumber
      signedUrl
    }
  }
}
`;

export const COMPLETE_INSTA360_UPLOAD_MULTIPART = gql`
  mutation completeInsta360UploadMultipart($projectId: Float!, $filename: String!, $uploadId: String!, $eTags: String!) {
    completeInsta360UploadMultipart(projectId: $projectId, filename: $filename, uploadId: $uploadId, eTags: $eTags)
  }
`;

export const GET_EXISTING_PACKAGE_UPLOADS = gql`
  query getExistingPackageUploads ($filenamesCsv: String!) {
    getExistingPackageUploads(filenamesCsv: $filenamesCsv) {
      filename
      size
    }
  }
`;
